import { type CommonAction, response } from "@iflyrpa/share";
import { z } from "zod";
import type { ActiomCommonParams, AxiosProxyParams } from "../../types";
import { Http } from "../../utils/http";
import { Xhshow } from "../../utils/xhsXsEncrypt";

// 小红书参数加密器
const xsEncrypt = new Xhshow();

export interface GroupListResponse {
    success: boolean;
    msg: string;
    data: {
        group_list: GroupDetail[];
    };
    code: number;
}

export const GroupDetailSchema = z.object({
    avatar: z.string(),
    desc: z.string(),
    group_id: z.string(),
    group_name: z.string(),
    linkable: z.boolean(),
});
export type GroupDetail = z.infer<typeof GroupDetailSchema>;

export type PublishAction = CommonAction<ActiomCommonParams, GroupDetail[]>;

export const getXhsGroup: PublishAction = async (_task, params) => {
    const headers = {
        cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        referer: "https://creator.xiaohongshu.com",
        origin: "https://creator.xiaohongshu.com",
    };
    const args: AxiosProxyParams = [
        { headers },
        _task.logger,
        params.proxyLoc,
        params.localIP,
        // params.huiwenToken,
        params.accountId,
    ];
    const http = new Http(...args);

    const a1Cookie = params.cookies.find((it) => it.name === "a1")?.value;
    if (!a1Cookie) return { code: 414, message: "账号数据异常，请重新绑定账号后重试。", data: [] };

    const groupListParams = { note_id: "" };
    const fatchGroup = "/api/im/web/nns/group_list";
    const recordCookie = params.cookies.reduce<Record<string, string>>((acc, cookie) => {
        if (cookie.name && cookie.value) {
            acc[cookie.name] = cookie.value;
        }
        return acc;
    }, {});
    const searchXsHeader = xsEncrypt.signHeadersGet(fatchGroup, recordCookie, "xhs-pc-web", groupListParams);

    const res = await http.api<GroupListResponse>(
        {
            method: "get",
            url: "https://edith.xiaohongshu.com/api/im/web/nns/group_list",
            params: groupListParams,
            headers: searchXsHeader,
        },
        { retries: 3, retryDelay: 20, timeout: 3000 },
    );

    const isSuccess = res.code === 0;
    const message = `群聊信息获取${isSuccess ? "成功" : `失败，原因：${res.msg}`}${_task.debug ? ` ${http.proxyInfo}` : ""}`;
    const data = isSuccess ? res.data.group_list : [];

    return response(isSuccess ? 0 : 414, message, data);
};
